import React from 'react';
import { SparklesIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function OpportunitySection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].opportunity;
  return <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-8 text-yellow-400" data-id="element-268">
          {t.title}
        </h2>
        <p className="text-lg md:text-xl text-center mb-8 md:mb-12 text-teal-200" data-id="element-269">
          {t.subtitle}
        </p>
        <div className="bg-gradient-to-br from-teal-950/50 to-black border border-teal-700/30 rounded-2xl p-6 md:p-12" data-id="element-270">
          <h3 className="text-xl md:text-2xl font-bold mb-6 md:mb-8 text-yellow-400" data-id="element-271">
            {t.heading}
          </h3>
          <div className="space-y-4 md:space-y-6" data-id="element-272">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-273">
              <SparklesIcon className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 flex-shrink-0" data-id="element-274" />
              <p className="text-base md:text-lg text-gray-200" data-id="element-275">
                {t.points[0]}{' '}
                <span className="text-teal-300 font-semibold" data-id="element-276">
                  {t.points[1]}
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 md:gap-4" data-id="element-277">
              <TrendingUpIcon className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 flex-shrink-0" data-id="element-278" />
              <p className="text-base md:text-lg text-gray-200" data-id="element-279">
                {t.points[2]}{' '}
                <span className="text-red-400 font-semibold" data-id="element-280">
                  {t.points[3]}
                </span>
              </p>
            </div>
            <div className="flex items-start gap-3 md:gap-4" data-id="element-281">
              <ZapIcon className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 flex-shrink-0" data-id="element-282" />
              <p className="text-base md:text-lg text-gray-200" data-id="element-283">
                {t.points[4]}{' '}
                <span className="text-teal-300 font-semibold" data-id="element-284">
                  {t.points[5]}
                </span>
              </p>
            </div>
          </div>
          <div className="mt-6 md:mt-10 p-4 md:p-6 bg-yellow-950/30 border border-yellow-600/30 rounded-xl" data-id="element-285">
            <p className="text-base md:text-lg leading-relaxed text-gray-200" data-id="element-286">
              <span className="text-yellow-400 font-bold" data-id="element-287">{t.warning}</span>{' '}
              {t.warningText}
            </p>
          </div>
        </div>
      </div>
    </section>;
}